import React from 'react'
import { Outlet, useNavigation } from 'react-router-dom'
import { createAmplifyListener } from '@meprism/shared/src/redux/authentication/createAmplifyListener'
import { usePageTracking } from '../../utils/hooks/usePageTracking'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Loader from '@meprism/shared/src/components/atoms/Loader'
import { ToastContainer } from 'react-toastify'
import { useMomentSciencePixel } from '../../utils/hooks/useMomentSciencePixel'
import { setAdAttributes, setUserIp } from '../../utils/helpers'
// required to style the toast
import 'react-toastify/dist/ReactToastify.css'
import { store } from '../../redux/store'

export const rootLayoutLoader = () => {
  store.dispatch(
    createAmplifyListener({
      onAutoSignInFailure: () => {
        window.location.href = `${window.location.origin}/login${window.location.search}`
      },
    }),
  )
  setAdAttributes()
  setUserIp()
  return null
}

export const RootLayout = () => {
  usePageTracking()
  useMomentSciencePixel()
  const navigation = useNavigation()
  const isRouteLoading = navigation.state === 'loading'

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100vh',
        flex: 1,
        px: 0,
      }}
      disableGutters
      maxWidth={false}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {isRouteLoading ? (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader loading={true} />
        </Box>
      ) : (
        <Outlet />
      )}
      {/* <MpFooter /> */}
    </Container>
  )
}
